/* =====================================================================
   LATAKAN - faq.js  (page "Foire aux questions")
   Accordeon + filtre par categorie (compteurs calcules depuis le DOM) +
   recherche plein texte (insensible aux accents) + "Tout developper" +
   injection du schema FAQPage. Chargee APRES core.js.
   ===================================================================== */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  var list = $('#faqList');
  if (!list) return;

  var items = $$('.qa', list);
  var cats = $$('.faqcat');
  var titleEl = $('#faqMainTitle');
  var countEl = $('#faqMainCount');
  var emptyEl = $('#faqEmpty');
  var expandBtn = $('#faqExpand');
  var searchInput = $('#faqSearch');
  var searchClear = $('#faqSearchClear');

  var LABELS = {
    all: 'Toutes les questions', commandes: 'Commandes', paiement: 'Paiement',
    livraison: 'Livraison', retours: 'Retours & Échanges', perso: 'Maillots & Personnalisation',
    tailles: 'Tailles & Coupe', entretien: 'Entretien', compte: 'Compte & Sécurité'
  };

  var currentCat = 'all';
  var term = '';

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function qText(qa) {
    if (qa._t) return qa._t;
    var q = $('.qa__lbl', qa), a = $('.qa__a', qa);
    qa._t = norm((q ? q.textContent : '') + ' ' + (a ? a.textContent : ''));
    return qa._t;
  }

  /* ----- compteurs (calcules une fois depuis le DOM) ----- */
  function computeCounts() {
    var by = { all: items.length };
    items.forEach(function (qa) {
      var c = qa.getAttribute('data-cat') || 'autre';
      by[c] = (by[c] || 0) + 1;
    });
    $$('.faqcat__n').forEach(function (n) {
      var k = n.getAttribute('data-count');
      if (by[k] != null) n.textContent = by[k];
    });
    return by;
  }

  function plural(n) { return n + ' question' + (n > 1 ? 's' : ''); }

  /* ----- application du filtre courant (categorie OU recherche) ----- */
  function apply() {
    var shown = 0;
    items.forEach(function (qa) {
      var ok;
      if (term) ok = qText(qa).indexOf(term) !== -1;
      else ok = (currentCat === 'all' || qa.getAttribute('data-cat') === currentCat);
      qa.hidden = !ok;
      if (ok) shown++;
    });

    if (titleEl) titleEl.textContent = term ? 'Résultats de recherche' : (LABELS[currentCat] || 'Questions');
    if (countEl) countEl.textContent = plural(shown);
    if (emptyEl) emptyEl.hidden = shown !== 0;

    syncExpandBtn();
  }

  /* ----- selection de categorie ----- */
  function selectCat(cat) {
    currentCat = cat;
    cats.forEach(function (b) {
      var on = b.getAttribute('data-cat') === cat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    apply();
    if (window.matchMedia('(max-width:1080px)').matches) {
      var main = $('.faqmain');
      if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  cats.forEach(function (b) {
    b.addEventListener('click', function () {
      if (term) { term = ''; if (searchInput) searchInput.value = ''; if (searchClear) searchClear.hidden = true; }
      selectCat(b.getAttribute('data-cat'));
    });
  });

  /* ----- accordeon ----- */
  function setOpen(qa, open) {
    qa.classList.toggle('is-open', open);
    var btn = $('.qa__q', qa);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  items.forEach(function (qa) {
    var btn = $('.qa__q', qa);
    if (!btn) return;
    btn.addEventListener('click', function () {
      setOpen(qa, !qa.classList.contains('is-open'));
      syncExpandBtn();
    });
  });

  /* ----- tout developper / tout reduire ----- */
  function visibleItems() { return items.filter(function (qa) { return !qa.hidden; }); }
  function syncExpandBtn() {
    if (!expandBtn) return;
    var vis = visibleItems();
    var allOpen = vis.length > 0 && vis.every(function (qa) { return qa.classList.contains('is-open'); });
    expandBtn.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    var lbl = $('span', expandBtn);
    if (lbl) lbl.textContent = allOpen ? 'Tout réduire' : 'Tout développer';
  }
  if (expandBtn) {
    expandBtn.addEventListener('click', function () {
      var vis = visibleItems();
      var allOpen = vis.length > 0 && vis.every(function (qa) { return qa.classList.contains('is-open'); });
      vis.forEach(function (qa) { setOpen(qa, !allOpen); });
      syncExpandBtn();
    });
  }

  /* ----- recherche ----- */
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      term = norm(searchInput.value.trim());
      if (searchClear) searchClear.hidden = !searchInput.value;
      if (term) {
        cats.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      } else {
        selectCat(currentCat);
        return;
      }
      apply();
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      term = ''; searchInput.value = ''; searchClear.hidden = true;
      searchInput.focus();
      selectCat(currentCat);
    });
  }

  /* ----- schema FAQPage (injecte depuis le contenu reel) ----- */
  function injectSchema() {
    try {
      var entities = items.map(function (qa) {
        var q = $('.qa__lbl', qa), a = $('.qa__a p', qa);
        return {
          '@type': 'Question',
          name: q ? q.textContent.trim() : '',
          acceptedAnswer: { '@type': 'Answer', text: a ? a.textContent.trim() : '' }
        };
      }).filter(function (e) { return e.name && e.acceptedAnswer.text; });
      if (!entities.length) return;
      var data = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities };
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
    } catch (e) {}
  }

  /* ----- lien profond : /pages/faq#livraison ouvre la categorie Livraison ----- */
  function fromHash() {
    var h = (location.hash || '').replace('#', '');
    if (h && LABELS[h]) {
      if (searchInput && searchInput.value) { searchInput.value = ''; term = ''; if (searchClear) searchClear.hidden = true; }
      selectCat(h);
    }
  }
  window.addEventListener('hashchange', fromHash);

  /* ----- init ----- */
  computeCounts();
  apply();
  injectSchema();
  fromHash();
})();
